/* Compare the selected unit price with the verified delivery rule in the
 * same currency. US has a fixed USD threshold; other rules are EUR.
 * Unknown/cross-currency eligibility fails closed, without FX estimates.
 */
function ttDeliveryEligible(data) {
  const price = Number(data.price);
  const threshold = Number(data.threshold);
  if (!data.thresholdCurrency || data.currency !== data.thresholdCurrency ||
      data.available !== 'true' || data.physical !== 'true' ||
      data.discounted === 'true' || !Number.isFinite(price) ||
      !Number.isFinite(threshold) || threshold <= 0) return false;
  return price >= threshold;
}

if (!customElements.get('tt-product-delivery')) {
  customElements.define('tt-product-delivery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('variant:selected', (event) => {
        if (event.target.closest?.('.shopify-section') !== this.closest('.shopify-section')) return;
        // Hide the previous variant's promise while the new price is loading.
        this.dataset.available = 'false';
        this.update();
      }, options);
      document.addEventListener('variant:update', (event) => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        const next = event.detail.data.html?.querySelector(`tt-product-delivery[data-product-id="${this.dataset.productId}"]`);
        // Use fresh server-rendered variant attributes, not stale product min/max.
        if (next && event.detail.resource) {
          for (const key of ['price', 'available', 'physical', 'discounted']) this.dataset[key] = next.dataset[key];
        } else {
          this.dataset.available = 'false';
        }
        this.update();
      }, options);
      // Discounts can change qualification. Fail closed until the next page load.
      document.addEventListener('discount:update', () => {
        this.dataset.discounted = 'true';
        this.update();
      }, options);
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      const eligible = ttDeliveryEligible(this.dataset);
      this.querySelector('.tt-delivery-benefit').hidden = !eligible;
      this.querySelector('.tt-delivery-fallback').hidden = eligible;
    }
  });
}
